import { post, apiPrefix } from './common';
const syncPaymentsGatewaySettlementAccount = (fundingSourceId) => post(`${apiPrefix}/PaymentsGatewaySettlementAccount/${fundingSourceId}/sync`, null);
const createPaymentsGatewaySettlementAccount = (bankAccount) => post(`${apiPrefix}/PaymentsGatewaySettlementAccount`, bankAccount);
export { syncPaymentsGatewaySettlementAccount, createPaymentsGatewaySettlementAccount };
